import React, { useEffect, useMemo, useState } from 'react';
import { normalizeLogoDataUri, stockMonogram } from '../logoPresentation';

const StockLogo = ({ symbol, source, loading = false }) => {
  const normalizedSource = useMemo(() => normalizeLogoDataUri(source), [source]);
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => setImageFailed(false), [normalizedSource]);

  if (loading) {
    return (
      <span
        role="status"
        aria-label={`Loading ${symbol} company mark`}
        className="flex h-12 w-12 items-center justify-center rounded-xl bg-slate-100 text-xs font-bold text-slate-500 dark:bg-slate-800 dark:text-slate-400"
      >
        …
      </span>
    );
  }

  if (!normalizedSource || imageFailed) {
    return (
      <span
        role="img"
        aria-label={`${symbol} company logo unavailable; ticker monogram shown`}
        data-logo-fallback={symbol}
        className="flex h-12 w-12 items-center justify-center rounded-xl border border-slate-200 bg-gradient-to-br from-slate-100 to-blue-50 px-1 text-center text-xs font-black tracking-tight text-slate-700 dark:border-slate-700 dark:from-slate-800 dark:to-blue-950 dark:text-slate-100"
      >
        {stockMonogram(symbol)}
      </span>
    );
  }

  return (
    <span className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-xl border border-slate-200 bg-white p-1.5 dark:border-slate-700 dark:bg-slate-900">
      <img
        src={normalizedSource}
        alt={`${symbol} company logo`}
        data-stock-logo={symbol}
        className="h-full w-full object-contain"
        onError={() => setImageFailed(true)}
      />
    </span>
  );
};

export default StockLogo;
